import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LanguageService } from '../../services';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';

@Component({
  selector: 'shared-breadcrumb',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslocoModule],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  @Input() data:any = [];
  private languageService = inject(LanguageService);
  isRtl = this.languageService.isRtl;
}
